export default function filterArray(array, attribute, search) {
  return (
    Array.isArray(array) &&
    array.filter((item) =>
      item[attribute].toLowerCase().includes(search.toLowerCase()),
    )
  )
}
